import axios from "../axios";
import {
    IGetMappingOptionsParams,
    IMappingCreateParams,
    IMappingEditParams,
    IMappingGetFaultDiagnosisAiParams,
    IMappingGetFaultDiagnosisAiParamsData,
    IMappingImportBindFileParams,
    IMappingImportFileData,
    IMappingImportFileParams,
    IMappingInfo,
    IMappingListPageData,
    IMappingListPageParams,
    IMappingOptions,
    IMappingUpdateFaultDiagnosisAiParams
} from "./mapping.types";

/**
 * 获取测点下拉框
 */
export function getMappingOptions(equipmentId: number, params?: IGetMappingOptionsParams) {
    return axios<IMappingOptions>({
        method: "get",
        url: `/mapping/list/${equipmentId}`,
        params,
    });
}

/**
 * 测点分页列表
 */
export function mappingListPage(params: IMappingListPageParams) {
    return axios<IMappingListPageData>({
        method: 'post',
        url: '/mapping/findPage',
        data: params,
    })
}

/**
 * 测点解绑
 */
export function mappingUnbindSensor(params: { mappingId: number }) {
    return axios({
        method: 'get',
        url: '/mapping/remove/sensor',
        params
    })
}

/**
 *测点新增 
 */
export function mappingCreate(params: IMappingCreateParams) {
    return axios({
        method: 'post',
        url: '/mapping/save',
        data: params,
    })
}

/**
 *测点编辑
 */
export function mappingEdit(params: IMappingEditParams) {
    return axios({
        method: 'post',
        url: '/mapping/edit',
        data: params,
    })
}

/**
 *  测点删除
 */
export function mappingDelete(params: { mappingId: string }) {
    return axios({
        method: 'post',
        url: '/mapping/del',
        params,
    })
}

/**
 * 获取某测点
 */
export function mappingInfo(params: { mappingId: number }) {
    return axios<IMappingInfo>({
        method: 'get',
        url: '/mapping/get',
        params,
    })
}


/**
 * 获取AI故障诊断参数
 */
export function mappingGetFaultDiagnosisAiParams(params: IMappingGetFaultDiagnosisAiParams) {
    return axios<IMappingGetFaultDiagnosisAiParamsData>({
        method: 'get',
        url: '/mapping/getFaultDiagnosisAiParams',
        params,
    })
}

/**
 * 修改AI故障诊断参数
 */
export function mappingUpdateFaultDiagnosisAiParams(params: IMappingUpdateFaultDiagnosisAiParams) {
    return axios({
        method: 'post',
        url: '/mapping/updateFaultDiagnosisAiParams',
        data: params
    })
}

/**
 * 设备测点绑定导入
 */
export function mappingImportBindFile(params: IMappingImportBindFileParams) {
    const f = new FormData()
    f.append('file', params.file)
    return axios({
        method: 'post',
        url: '/mapping/importBindFileV2',
        data: f,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    })
}

/**
 * 设备测点导入
 */
export function mappingImportFile(params: IMappingImportFileParams) {
    const f = new FormData()
    f.append('file', params.file)
    return axios<IMappingImportFileData>({
        method: 'post',
        url: '/mapping/mappingImportFileV2',
        data: f,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    })
}
